import { useEffect, useState } from 'react';
import { invalidateEntity, setRealtimeConnected } from './queryClient.js';

/**
 * Assina as mudanças do lar via SSE. Cada evento só diz QUAL tipo de dado mudou; o front
 * refaz as consultas afetadas. EventSource reconecta sozinho; enquanto estiver desconectado,
 * as consultas passam a ser atualizadas periodicamente (ver queryClient.js).
 */
export function useRealtime(householdId, userId) {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!householdId || typeof EventSource === 'undefined') return undefined;
    const es = new EventSource(`/api/households/${householdId}/stream`);
    const pending = new Set();
    let timer = null;

    es.addEventListener('ready', () => {
      setConnected(true);
      setRealtimeConnected(true);
    });
    es.addEventListener('change', (ev) => {
      try {
        const msg = JSON.parse(ev.data);
        // Alterações feitas por mim já atualizaram a tela; notificações sempre recarregam.
        if (msg.actorId && msg.actorId === userId && msg.entity !== 'notifications') return;
        pending.add(msg.entity);
        clearTimeout(timer);
        timer = setTimeout(() => {
          for (const e of pending) invalidateEntity(householdId, e);
          pending.clear();
        }, 250);
      } catch {
        /* ignora evento malformado */
      }
    });
    es.onerror = () => {
      setConnected(false);
      setRealtimeConnected(false);
    };
    return () => {
      clearTimeout(timer);
      es.close();
      setConnected(false);
      setRealtimeConnected(false);
    };
  }, [householdId, userId]);

  return connected;
}
